import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* getAllTaskType(action: any): SagaReturnType<any> {
    try {
        const response = yield call(therapistSchedulingServices.getAllTaskType, action.payload);
        if (response?.status === 200) {
            yield put({ type: TherapistAction.GET_ALL_TASK_TYPE_SUCCESS, payload: response.data });
            yield put({
                type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST, payload: {
                    providerId: action.payload.providerId,
                    localDate: action.payload.data.localDate,
                }
            });
        } else {
            throw response.data;
        }
    } catch (error) {
        yield put({ type: TherapistAction.GET_ALL_TASK_TYPE_FAILURE, payload: error });
    }
}

function* getAllTaskTypeSaga() {
    yield takeEvery(TherapistAction.GET_ALL_TASK_TYPE_REQUEST, getAllTaskType);
}

export default getAllTaskTypeSaga;
